<template>
    <div class="contentWrap joinsect">
        <div class="joinsect_content">
            <!-- title -->
            <div class="joinsectCon_title">
                <div class="joinsectConTit_sort">
                    <p>排序</p>
                    <span v-for="(item,index) in sortList" :class="listQuery.orderType == item.type?'checkedNav':''" @click="sortFn(item)" :key="index">{{item.name}}</span>
                </div>
                <div class="joinsectCon_search">
                    <input v-model="listQuery.familyName" type="text">
                    <button @click="GetFamilyListFn()">搜索</button>
                </div>
            </div>
            <!-- 内容 -->
            <div class="joinsectCon_box">
                <div class="joinsectCon_item" v-for="(item,index) in tableList" :key="index">
                    <span>{{item.familyName}}</span>
                    <div>
                        <span>宗主</span>
                        <p>{{item.master}}</p>
                    </div>
                    <p class="desire">{{item.familyNotice}}</p>
                    <p class="assemble">已集结<span>{{item.userCount}}</span>名仙友</p>
                    <img @click="getDetail(item)" src="../assets/detail_btn.png" alt="">
                    <em>{{item.familyFeature}}</em>
                </div>
 
                </div>
               <div style="clear:both;text-align:center;">
                                    <el-pagination
  background
  layout="prev, pager, next"
  :page-size="listQuery.pageSize"
   @current-change="currentChange"
   :page-count='10'
   
  :total="total">
</el-pagination>
            </div>
            <!-- 查看详情 -->
            <div class="sect_detail" v-if="seeDetailState">
                <img @click="seeDetailState = false"  src="../assets/sectDetailClose_btn.png" alt="">
                <p class="sectDetail_title">"{{sectDetail.familyName}}"欢迎您</p>
                <ul>
                    <li>{{sectDetail.master}}</li>
                    <li>{{sectDetail.tel}}</li>
                    <li>{{sectDetail.familyFeature}}</li>
                </ul>
                <div>
                        <div>
                            <img :src="service_url+sectDetail.weixinCode" alt="">
                        </div>
                        <ol>
                            <li @mouseover="mouseoverIcon(index,0)" @mouseout="mouseoutIcon(index,0)"  :class="index == 0?'one':''" v-for="(item,index) in sectPrize" :key="index">
                                <img :src="item.icon" alt="">
                                <span v-if="item.info"><img :src="item.tips" alt=""></span>
                            </li>
                        </ol>
                        <ol>
                          <li @mouseover="mouseoverIcon(index,1)" @mouseout="mouseoutIcon(index,1)" :class="index == 0?'one':''" v-for="(item,index) in taskData" :key="index">
                              <img :src="item.icon" alt="">
                              <span v-if="item.info"><img :src="item.tips" alt=""></span>
                          </li>
                        </ol>
                </div>
      
                <div class="sectDetail_btn">
                    <img  @mouseout="hoverOver(1,'sure_join.png')" @mouseover="hoverOver(1,'surehigh_join.png')" @click="JoinFamilyFn()" :src="saveBtn" alt="">
                    <img @mouseout="hoverOver(2,'secDetail_back.png')" @mouseover="hoverOver(2,'secDetailhigh_back.png')" @click="seeDetailState = false" :src="backBtn" alt="">
                </div>
            </div>
        </div>
        <bindRole @closeBindRole="closeBindRole" v-if="bindState"></bindRole>
    </div>
</template>
<script>
import bindRole from '@/components/bindRole'
import { GetFamilyList , JoinFamily} from '@/untils/authority'
export default {
    name:'joinZongmen',
      components:{
        bindRole
    },
    data(){
        return {
            seeDetailState:false,
            bindState:false,
            saveBtn:require('@/assets/sure_join.png'),
            backBtn:require('@/assets/secDetail_back.png'),
            total:0,
            sortList:[
                {
                    name:'最新',
                    type:1,
                },
                {
                    name:'最热',
                    type:2,
                },
            ],
                      service_url: process.env.VUE_APP_upload_URL
        ? process.env.VUE_APP_upload_URL
        : "",
            listQuery:{
                orderType:2,
                familyName:'',
                pageIndex:1,
                pageSize:10,
            },
              taskData:[
                    {
                        name:'45级强化石*20',
                        icon:require('../assets/reward/1003qhs.png'),
                        tips:require('../assets/reward/1003qhs2.png'),
                        info:false
                    },
                    {
                        name:'天女丝囊*5',
                        icon:require('../assets/reward/1055tnsn.png'),
                        tips:require('../assets/reward/1055tnsn2.png'),
                        info:false
                    },
                    {
                        name:'高级鉴定符*10',
                        icon:require('../assets/reward/1072gjjdf.png'),
                        tips:require('../assets/reward/1072gjjdf2.png'),
                        info:false
                    },
                    {
                        name:'碎银20w',
                        icon:require('../assets/reward/292sy.png'),
                        tips:require('../assets/reward/292sy2.png'),
                        info:false
                    },
                    {
                        name:'庇佑符*1',
                        icon:require('../assets/reward/1050byf.png'),
                        tips:require('../assets/reward/1050byf2.png'),
                        info:false
                    },
            ],
            sectPrize:[
   {
                        name:'天女丝囊*5',
                        icon:require('../assets/reward/1055tnsn.png'),
                        tips:require('../assets/reward/1055tnsn2.png'),
                        info:false
                    },
                    {
                        name:'15级强化石*20',
                        icon:require('../assets/reward/1001qhs.png'),
                        tips:require('../assets/reward/1001qhs2.png'),
                        info:false
                    },
                    {
                        name:'鉴定符*2',
                        icon:require('../assets/reward/1071jdf.png'),
                        tips:require('../assets/reward/1071jdf2.png'),
                        info:false
                    },
                    {
                        name:'紫金珠*2',
                        icon:require('../assets/reward/1309zjz.png'),
                        tips:require('../assets/reward/1309zjz2.png'),
                        info:false
                    },
                    {
                        name:'修仙盟任务卷*1',
                        icon:require('../assets/reward/21000xxmtgjz.png'),
                        tips:require('../assets/reward/21000xxmtgjz2.png'),
                        info:false
                    },
            ],
            sectDetail:{},
            tableList:[]
        }
    },
    mounted(){
        this.GetFamilyListFn()
    },
    methods:{
        // 宗门列表
        GetFamilyListFn(){
            GetFamilyList(this.listQuery).then(response => {
                if(response.result == 1){
                    this.tableList = response.data
                    this.total = response.total
                }else{
                    alert(response.message)
                }
            })
        },
      currentChange(page) {
         this.listQuery.pageIndex = page
         this.GetFamilyListFn()
      },
         hoverOver(type,url){
            if(type== 1){
                this.saveBtn = require('@/assets/'+url)
            }else{
                this.backBtn = require('@/assets/'+url)
            }
        },
       closeBindRole(data){
            this.bindState = false
            console.log(data)
             this.$store.commit('SET_ROLENAME', data.roleName)
        },
        mouseoverIcon(index,type){
            if(type == 1){
                this.taskData[index].info = true
            }else{
                   this.sectPrize[index].info = true
            }
         
        },
        mouseoutIcon(index,type){
            if(type == 1){
                this.taskData[index].info = false
            }else{
                   this.sectPrize[index].info = false
            }
          
        },
        // 加入宗门
        JoinFamilyFn(item){
            JoinFamily({'familyID':this.sectDetail.familyId}).then(response => {
                 if(response.result == 1){
                     this.seeDetailState = false
                     alert('加入成功')
                }else{
                    alert(response.message)
                    if(response.result == 7){
                        this.bindState = true
                    }
                    if(response.result == 0){
                         location.href = `http://passport.ourgame.com/lzgamelogin!webhallb.do?from=video&nexturl=`+location.href
                    }
                }
            })
        },
        sortFn(item){
            this.listQuery.orderType = item.type
            this.GetFamilyListFn()
        },
        getDetail(item){
            this.sectDetail = Object.assign(this.sectDetail,item)
            this.seeDetailState = true
        }
    }
}
</script>
<style lang="less">
.contentWrap{
    
         width:100%;
         background-position: center;
         height:100vh;
         position: relative;
}
.joinsect{
 background: rgba(0,0,0,0.8) url('../assets/bg.jpg');
}
.checkedNav{
    background-color: rgba(179, 112, 60, 1);
}
.joinsect_content{
    width: 1234px;
    position: absolute;
    top:0px;
    left:0px;
    right:0px;
    bottom:0px;
    margin:auto;
	height: 718px;
	background:url(../assets/content_bg.png);
    padding:24px 10px;
    box-sizing: border-box;
    .joinsectCon_title{
        overflow: hidden;
        .joinsectConTit_sort{
            float:left;
            >p{
                color: #fcf5c6;
                font-size: 20px;
                padding:0px 13px 0px 6px;
                float:left;
            }
            >span{
                float:left;
            	width: 40px;
                text-align: center;
                font-size: 12px;
	            height: 17px;
                line-height:17px;
                color: #fcf5c6;
                float:left;
                margin-top:6px;
            }
            .checkedTit_sort{
	            background-color: #b3703c;
            }
        }
        .joinsectCon_search{
            float:right;
             border: solid 1px #b3703c;
                width: 258px;
	            height: 22px;
            input{
               width:208px;
               height:20px;
               background:#131530;
               color: #fcf5c6;
               border:0px;
               float:left;
            }
            button{
                width:46px;
                height:22px;
                background-color: #b3703c;
                color: #fcf5c6;
                border:0px;
                float:left;
            }
        }
    }
       .joinsectCon_box::-webkit-scrollbar{
        width:10px;
        height:10px;
        /**/
        }
    //     .joinsectCon_box::-webkit-scrollbar-track{
    //     background: rgba(239, 162, 103, 1);
    //     	border: solid 2px rgba(193, 114, 52, 1);
    //     border-radius:2px;
    //     }
    //     .joinsectCon_box::-webkit-scrollbar-thumb{
    //    background-color: rgba(244, 138, 55, 1);
    //    	border: solid 2px rgba(193, 114, 52, 1);
    //     border-radius:10px;
    //     }
    //     .joinsectCon_box::-webkit-scrollbar-thumb:hover{
    //     background-color: rgba(244, 138, 55, 1);
	// border: solid 2px rgba(193, 114, 52, 1);
    //     }
    //     .joinsectCon_box::-webkit-scrollbar-corner{
    //             background-color: rgba(244, 138, 55, 1);
    //     }
    .joinsectCon_box{
        margin-left:-24px;
        overflow-y: scroll;
     height: 613px;
        .joinsectCon_item{
            float:left;
            margin-top:26px;
        	width: 219px;
	height: 301px;
    background:url('../assets/sectItem_bg.png') no-repeat;
    background-size:100%;
    box-sizing: border-box;
            // text-align: center;
            padding:0px 15px;
            margin-left:24px;
            >span{
                display: block;
                color: rgba(215, 207, 148, 1);
                text-align:center;
                line-height:28px;
                margin-top:27px;
                width:106%;
                text-align: center;
            }
            .desire{
                width: 148px;
                height: 70px;
                background-color: rgba(12, 14, 40, .8);
                color: rgba(252, 245, 198, 1);
                font-size: 12px;
  padding:4px 7px 0px 7px;
  margin:0px auto;
  margin-top:9px;
  overflow: hidden;
  box-sizing: border-box;
            }
            .assemble{
              
                text-align: center;
                	color: rgba(252, 245, 198, 1);
                    font-size: 14px;
                    span{
                        font-size: 21px;
                    }
            }
            img{
                width: 136px;
	height: 42px;
    display: block;
    margin:9px auto;
            }
            >em{
               color: rgba(252, 245, 198, 1); 
               	font-size: 14px;
                // padding-top:10px;
                clear: both;
                display: block;
                font-style:normal;
                text-align: center;
            }
            >div{
                  color: #fcf5c6;
               
                  overflow: hidden;
                    font-size: 15px;
                    	width: 148px;
                        margin:0px auto;
                           margin-top:13px;
                span{
                    width: 52px;
                    height: 28px;
                    background-color: #424680;
                    display: block;
                    text-align:center;
                    line-height:28px;
                  
                    float:left;
                }
                p{
                    text-align:center;
                    line-height:28px;
                    height: 28px;
                    float:left;
                    width:96px;
                    background:rgba(18,20,46,.8);
                    // padding:4px 8px 0px;
                }
            }
        }
    }
    .sect_detail{
        width: 1109px;
        height: 691px;
        background:url(../assets/sect_detailBg.png);
        position: absolute;
        top:0px;
        left:0px;
        right:0px;
        bottom:0px;
        margin:auto;
        z-index: 99;
        >img{
            position: absolute;
            right:-44px;
        }
        .sectDetail_title{
            color: rgba(215, 207, 148, 1);
            font-size: 34px;
            margin-top:25px;
            text-align: center;
        }
        >ul+div{
            float:left;
            // clear:;
            margin-top:167px;
            div{
                width: 224px;
	            height: 287px;
                text-align: center;
                margin-left:94px;
                // line-height:287px;
                float:left;
                img{
                    	width: 161px;
                        padding-top:65px;

	                    height: 161px;
                }
            }
            ol{
                width: 246px;
	            height: 287px;
                margin-left:105px;
                float:left;
                // padding-top:16px;
                box-sizing: border-box;
                // padding:16px 30px 0px 30px;
                li{
                    float:left;
                    margin-left:22px;
                    margin-top:14px;
                    position: relative;
                    top:0px;
                    left:0px;
                      span{
                                width: 246px;
                                position: absolute;
                                top:0px;
                                left:-256px;
                                background:rgb(201,102,22);
                                border:1px solid rgb(253,150,66);
                                box-sizing: border-box;
                                z-index: 99;
	                            // height: 165px;
                                padding:9px;
                                img{
                                 width: 228px;
                                    // height: 149px;
                                }
                            }
                }
                .one{
                    text-align: center;
                    width:100%;
                    margin-left:0px;
                    span{
                        left:-190px;
                    }
                }
            }
        
        }
        ul{
            margin-top:16px;
            padding-left:196px;
            li{
                float:left;
                width:330px;
                font-size: 15px;
                color: rgba(252, 245, 198, 1);
            }
            li+li+li{
                width:132px;
                margin-left:38px;
            }
        }
        ol{
            li{
                float:left;
                >img{
                  width: 68px;
	                height: 68px;  
                }
            }
        }
        .sectDetail_btn{
            text-align: center;
            padding-top:20px;
            clear: both;
            // overflow: hidden;
            img+img{
                display:inline-block ;
                margin-left:100px;
            }
        }
    }
}
</style>